import React from 'react'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getVerticalLogo } from 'lib/images'

import VerticalBackLink from 'components/Navigation/VerticalBackLink/VerticalBackLink'
import Icon from 'components/Icon'

import './app-header-desktop-vertical-back.pcss'

const AppHeaderDesktopVerticalBack = () => {
    return (
        <VerticalBackLink className="app-header-desktop-vertical-back">
            {({ name }) => (
                <>
                    <Icon name="icon_chevron_left_white" />
                    {getVerticalLogo(name, true, 'white')}
                </>
            )}
        </VerticalBackLink>
    )
}

AppHeaderDesktopVerticalBack.propTypes = {

}

export default flowRight(
    withErrorBoundaryNoRender,
)(AppHeaderDesktopVerticalBack)
